import React, {Component, RefObject} from 'react';
import './App.css';
import MusicPlayer from "./components/rap-battle/MusicPlayer";
import Pager from "./components/rap-battle/Pager";

// @ts-ignore
import sound0 from './assets/mp3/level_0.mp3';
// @ts-ignore
import sound1 from './assets/mp3/level_1.mp3';
// @ts-ignore
import sound2 from './assets/mp3/level_2.mp3';
// @ts-ignore
import sound3 from './assets/mp3/level_3.mp3';
// @ts-ignore
import sound4 from './assets/mp3/level_4.mp3';

// @ts-ignore
import sample1 from './assets/mp3/sample_1.mp3';
// @ts-ignore
import sample2 from './assets/mp3/sample_2.mp3';

// @ts-ignore
import lv1_1 from './assets/mp3/level1-1.mp3';
// @ts-ignore
import lv1_2 from './assets/mp3/level1-2.mp3';
// @ts-ignore
import lv1_3 from './assets/mp3/level1-3.mp3';
// @ts-ignore
import lv2_1 from './assets/mp3/lv2-1.mp3';
// @ts-ignore
import lv2_2 from './assets/mp3/lv2-2.mp3';
// @ts-ignore
import lv2_3 from './assets/mp3/lv2-3.mp3';
// @ts-ignore
import lv3_1 from './assets/mp3/level3-1.mp3';
// @ts-ignore
import lv3_2 from './assets/mp3/level3-2.mp3';
// @ts-ignore
import lv3_3 from './assets/mp3/level3-3.mp3';


// @ts-ignore
import lv1_1c from './assets/mp3/level1-1c.mp3';
// @ts-ignore
import lv1_2c from './assets/mp3/level1-2c.mp3';
// @ts-ignore
import lv1_3c from './assets/mp3/level1-3c.mp3';
// @ts-ignore
import lv2_1c from './assets/mp3/lv2-1c.mp3';
// @ts-ignore
import lv2_2c from './assets/mp3/lv2-2c.mp3';
// @ts-ignore
import lv2_3c from './assets/mp3/lv2-3c.mp3';
// @ts-ignore
import lv3_1c from './assets/mp3/level3-1c.mp3';
// @ts-ignore
import lv3_2c from './assets/mp3/level3-2c.mp3';
// @ts-ignore
import lv3_3c from './assets/mp3/level3-3c.mp3';

import refresh from './assets/img/refresh-2.png';

import ReactPlayer from "react-player";
// import Background from './assets/img/background.png';
import Background from './assets/img/bg.jpg';
import { unregister } from './serviceWorker';

console.log('version: 0.0.3');

interface Props {}
interface State {
    playingDisk: boolean[];
}

class App extends Component<Props, State> {
    public state: State = {playingDisk: [false, false, false, false, false,false, false, false, false, false, false, false, false, false,false, false, false, false]};
    private player1Ref: any;
    private player2Ref: any;
    constructor(props: Readonly<Props>) {
        super(props);
        this.player1Ref = React.createRef();
        this.player2Ref = React.createRef();
    }

    refresh() {
        unregister();
        window.location.reload();
    }

    render() {
        return (
            <div className="App" style={{ paddingTop: 30, background: `url(${Background})`, backgroundSize: 'cover' }} >
                <img src={refresh} onClick={() => this.refresh()} style={{ position: 'absolute', top: 10, left: 10, zIndex: 0, width: 20 }}/>
                <Pager pages={[
                    // <MusicPlayer music={sound0} title={'Level 0'} play={this.state.playingDisk[2]} toggle={() => this.togglePlay(2)} />
                    <MusicPlayer music={lv1_1} title={'Lv.1 #01'} play={this.state.playingDisk[0]} toggle={() => this.togglePlay(0)} playCypher={this.state.playingDisk[9]} toggleCyper={() => this.togglePlay(9)} cyper={lv1_1c} />,
                    <MusicPlayer music={lv1_2} title={'Lv.1 #02'} play={this.state.playingDisk[1]} toggle={() => this.togglePlay(1)} playCypher={this.state.playingDisk[10]} toggleCyper={() => this.togglePlay(10)} cyper={lv1_2c} />,
                    <MusicPlayer music={lv1_3} title={'Lv.1 #03'} play={this.state.playingDisk[2]} toggle={() => this.togglePlay(2)} playCypher={this.state.playingDisk[11]} toggleCyper={() => this.togglePlay(11)} cyper={lv1_3c} />,
                    <MusicPlayer music={lv2_1} title={'Lv.2 #01'} play={this.state.playingDisk[3]} toggle={() => this.togglePlay(3)} playCypher={this.state.playingDisk[12]} toggleCyper={() => this.togglePlay(12)} cyper={lv2_1c} />,
                    <MusicPlayer music={lv2_2} title={'Lv.2 #02'} play={this.state.playingDisk[4]} toggle={() => this.togglePlay(4)} playCypher={this.state.playingDisk[13]} toggleCyper={() => this.togglePlay(13)} cyper={lv2_2c} />,
                    <MusicPlayer music={lv2_3} title={'Lv.2 #03'} play={this.state.playingDisk[5]} toggle={() => this.togglePlay(5)} playCypher={this.state.playingDisk[14]} toggleCyper={() => this.togglePlay(14)} cyper={lv2_3c} />,
                    <MusicPlayer music={lv3_1} title={'Lv.3 #01'} play={this.state.playingDisk[6]} toggle={() => this.togglePlay(6)} playCypher={this.state.playingDisk[15]} toggleCyper={() => this.togglePlay(15)} cyper={lv3_1c} />,
                    <MusicPlayer music={lv3_2} title={'Lv.3 #02'} play={this.state.playingDisk[7]} toggle={() => this.togglePlay(7)} playCypher={this.state.playingDisk[16]} toggleCyper={() => this.togglePlay(16)} cyper={lv3_2c} />,
                    <MusicPlayer music={lv3_3} title={'Lv.3 #03'} play={this.state.playingDisk[8]} toggle={() => this.togglePlay(8)} playCypher={this.state.playingDisk[17]} toggleCyper={() => this.togglePlay(17)} cyper={lv3_3c} />,
                ]} width={'320px'}/>
                <h4 style={{opacity: 0.8, marginTop: 400}}>← スライドでレベル変更 →</h4>
                {/* <div style={{
                    width: '100%',
                    height: 100,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: 30
                }}>
                    <div style={{
                        width: '50%',
                        height: 100,
                        borderColor: '#fff',
                        borderWidth: 3,
                        borderStyle: 'dashed',
                        margin: 20,
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        backgroundColor: this.state.playingDisk[0] ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0)'
                    }} onClick={() => this.togglePlay(0)}>
                        <h3>サンプル1</h3>
                        <ReactPlayer url={sample1} playing={this.state.playingDisk[0]} ref={this.player1Ref} onStop={this.onStop1()} width={0} height={0}/>
                    </div>
                    <div style={{
                        width: '50%',
                        height: 100,
                        borderColor: '#fff',
                        borderWidth: 3,
                        borderStyle: 'dashed',
                        margin: 20,
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        backgroundColor: this.state.playingDisk[1] ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0)'
                    }} onClick={() => this.togglePlay(1)}>
                        <h3>サンプル2</h3>
                        <ReactPlayer url={sample2} playing={this.state.playingDisk[1]} ref={this.player2Ref} onStop={this.onStop2()} width={0} height={0}/>
                    </div>
                </div> */}
            </div>
        );
    }

    private togglePlay(id: number) {
        this.setState(currentState => {
            let playingDisk = currentState.playingDisk.map((v, i) => (id === i ? !v : false));
            return { playingDisk: playingDisk };
        })
    }

    // private onStop1() {
    //     if (this.player1Ref.current) {
    //         this.player1Ref.current.seekTo(0, 'fraction')
    //     }
    // }
    // private onStop2() {
    //     if (this.player2Ref.current) {
    //         this.player2Ref.current.seekTo(0, 'fraction')
    //     }
    // }
}

export default App;
